import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {DigitalSignatureMissingModalComponent} from './digital-signature-missing-modal';

export const DigitalSignatureMissingModalModule: string = ng
  .module('digital-signature-missing-modal', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('digitalSignatureMissingModal', DigitalSignatureMissingModalComponent)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-step1/digital-signature-missing-modal/digital-signature-missing-modal.module.ts